

export default function normalizeValues (value) {
    return value.replace('R$', '').replace(/\s/g, '').replace(',', '.');
};